<p-toast position="top-center"></p-toast>

<p-dialog
    [(visible)]="loading"
    [showHeader]="false"
    [resizable]="false"
    [modal]="true"
    [focusOnShow]="false"
    class="progress-overlay">

    <div class="executive-loading-container text-center">
        <p-progressSpinner styleClass="executive-loading-spinner"></p-progressSpinner>
    </div>
</p-dialog>

<div class="executive-filter-toolbar">
    <div class="executive-filter-controls">
        <div id="serviceGrpApp">
          <app-service-grp-select [defaultService]="filter.serviceGroup" (serviceGrpSelected)="onServiceGrpChanged($event)"></app-service-grp-select>
        </div>
        <div id="locationApp">
          <app-location-select 
            #locationSelectComp
            [user]="authService.user" 
            [footprint]="footprint"
            [deId]="deId" 
            [filter]="locationSelectFilter" 
            [showReset]="false"
            (locationSelected)="onLocationChanged($event)"
            (initComplete)="onLocationSelectInitialized($event)"
            >
          </app-location-select>
        </div>
    </div>
    <div class="executive-filter-actions">
        <app-refresh-button class="dashboard-refresh-button" (refresh)="refreshToInitialState()"></app-refresh-button>
    </div>
        <!-- <div class="col-md-2 ml-auto" id="filterBTN">
            <span pTooltip="Filter Dates" tooltipPosition="bottom" style="padding-right: 10px;">
                <p-button (click)="showDateFilter()" icon= "pi pi-calendar" styleClass="p-button-secondary"></p-button>
            </span>
            <span pTooltip="Advance Filter" tooltipPosition="bottom">
              <p-button (click)="openFilterModal()" icon="pi pi-filter" styleClass="p-button-secondary"></p-button>
            </span>
        </div> -->
</div>

<div class="row regionAndChart">
    <div class="col-md-auto">
        <p-card header="Comparison Metrics" class="PieChart comparison-metrics-card">
            <div class="comparison-metrics-container">
                <div class="charts-row">
                    <div class="chart-item">
                        <p-chart type="doughnut" [data]="interactionTotal" [options]="interactionOptions" width="250" height="250"></p-chart>
                    </div>
                    <div class="chart-item">
                        <p-chart type="doughnut" [data]="discrepanciesTotal" [options]="discrepanciesOptions" width="250" height="250"></p-chart>
                    </div>
                    <div class="chart-item">
                        <p-chart type="doughnut" [data]="highRiskDiscrepancies" [options]="highRiskOptions" [plugins]="plugin" width="250" height="250"></p-chart>
                    </div>
                    <div class="chart-item">
                        <p-chart type="doughnut" [data]="adminCount" [options]="adminCountOptions" width="250" height="250"></p-chart>
                    </div>
                </div>
                <div class="legend-column">
                    <div class="legend-header">
                        <div class="legend-header-facility">{{loc_filter_breakdown === 'LocationGrouping' ? 'Areas' : loc_filter_breakdown === 'adcDevice' ? 'Stock Area' : loc_filter_breakdown}}</div>
                        <div class="legend-header-rate">High Risk Res. Rate</div>
                    </div>
                    <div class="legend-data-container">
                        <ng-container *ngFor="let rowData of regionDescrep.regionData; let i = index; trackBy: trackByIndex">
                            <div class="legend-item" *ngIf="rowData && getDescrpeLabel(rowData) && getDescrpeLabel(rowData) !== 'N/A' && getDescrpeLabel(rowData) !== ''">
                                <div class="legend-color-box" [ngStyle]="getRegionBg(rowData)"></div>
                                <div class="legend-facility-name">{{ isDeId(getDescrpeLabel(rowData))}}</div>
                                <div class="legend-rate-value">{{ getDiscrepincyRate(rowData) }}</div>
                            </div>
                        </ng-container>
                    </div>
                    <div class="combination-rate">
                        <div class="combination-rate-label">Combination Rate</div>
                        <div class="combination-rate-value">{{ regionDescrep.totalDiscrepincyRate }}%</div>
                    </div>
                </div>
            </div>
        </p-card>
    </div>
</div>

<div class="row executive-summary-and-risk">
  <div class="col-md-auto summary-padding">
    <div class="summary-cards-row">
      <div class="summary-card-wrapper">
          <p-card header="High Risk Variances" class="summary-card">
              <h1>{{totalHighRiskResolutions}}</h1>
          </p-card>
      </div>
      <div class="summary-card-wrapper">
          <p-card header="Total Variances" class="summary-card">
              <h1>{{totalResolutions}}</h1>
          </p-card>
      </div>
      <div class="summary-card-wrapper">
          <p-card header="High Risk Variance Rate" class="summary-card">
              <h1>{{ regionDescrep.totalDiscrepincyRate }}%</h1>
          </p-card>
      </div>
    </div>
  </div>

  <div class="col-md-auto riskChart">
      <div id="highRiskChart">
          <p-card header="User Score, Sorted High to Low" class="HighRiskSort executive-risk-table-card">
              
                <p-table #adminRiskTable [value]="adminHighRiskData" [paginator]="true" [rows]="9" [lazy]="true" [totalRecords]="auditTableCount" (onLazyLoad)="loadAdminHighRisk($event)">
                  <ng-template pTemplate="header">
                      <tr class="table-header" >
                          <th class="share-col-header">
                            User ID
                          </th>
                          <th>User Name</th>
                          <th>Role</th>
                          <th>Area</th>
                          <th>
                              <span pTooltip="MAAP RISK" tooltipPosition="bottom">User Score <br>(90 Day)
                                  <div class="table-risk-level">
                                      <div class='gradient-dark-blue text-white resolutions'>
                                          <img src="/assets/images/icon_red_square.png" alt=""> Highest Risk 
                                      </div>
                                      <div class='gradient-dark-blue text-white resolutions' >
                                          <img src="/assets/images/icon_yellow_triangle.png" alt=""> Moderate Risk
                                      </div>
                                      <div class='gradient-dark-blue text-white resolutions' >
                                          <img src="/assets/images/icon_green_circle.png" alt=""> Low Risk or No Risk
                                      </div>
                                  </div>
                              </span>
                          </th>
                          <th class="audit-high-risk">
                              High Risk
                          </th>
                          <th class="follow-up-header">
                            Follow Up Status
                          </th>
                      </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-rowData let-columns="columns">
                      <tr>
                          <td>{{ isDeId(rowData?.lanId) }}</td>
                          <td class="tableRow">
                              {{ isDeId(rowData?.employeeName) }}
                          </td>
                          <td class="table-text-small">{{ rowData?.adminGroup }}</td>
                          <td class="table-text-small">{{ isDeId(rowData?.locationGroupingString) }}</td>
                          <td tabindex="0" id="MaapRiskStyle" class="risk-score-cell"
                              (click)="isMultiple(rowData)?null:openRiskScoreChart(rowData)">
                              <div [ngClass]="'risk-flag-' + getRiskFlag(rowData)" class="risk-flag-shape"></div>
                              <img [src]="getScoreMovement(rowData)" alt="{{rowData?.scoreMovement}}" id="scoreStyle"> 
                          </td>
                          <td>
                              <a tabindex="0" class="table-action-link"
                                  (click)="showIndividualDiscrepancy(rowData, 'highRisk')" (keydown.enter)="showIndividualDiscrepancy(rowData, 'highRisk')"
                                  >{{ rowData?.highRisk }}
                              </a>
                          </td>
                          <td class="position-relative">
                            <div *ngIf="rowData?.parent" [class]="getClass(rowData?.followUp)" id="colorBox">
                              <div class="position-relative follow-up-label">{{ getFollowUp(rowData?.followUp) }}</div>
                            </div>
                            <div *ngIf="rowData?.notes !== '' || rowData?.notes === null || rowData?.notes === undefined" class="iconBox">
                            <img tabindex="0"
                              class="maap-icon-Style float-right"
                              src="/assets/images/icon_edit.png"
                              alt="Edit notes"
                              (click)="showCommentEdit(rowData)" (keydown.enter)="showCommentEdit(rowData)">
                            </div>
                          </td>
                      </tr>
                  </ng-template>
                </p-table>
          </p-card>
      </div>
  </div>
</div>

<div class="row FollowUpRow">
  <div class="col-12 tableStyle">
    <p-card header="Current Follow Up Status by Auditor" class="followUp-table" > 
        <div class="row tableStyle">
            <div class="col-12">             
                <p-table [columns]="adminCountCol" [value]="adminCountReport" [paginator]="true" [rows]="10" [showCurrentPageReport]="true">
                   <ng-template pTemplate="header">
                        <tr class="table-header">
                            <th>
                                Auditor
                            </th>
                            <th *ngFor="let col of adminCountCol, let last = last" [ngStyle]="last ? {'border-top-right-radius': '10px'} : {}">
                                {{ col.header }}
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr>
                            <td>{{isDeId(rowData?.investigator)}}</td>
                            <td tabindex="0" *ngFor="let col of adminCountCol" [ngStyle]="getCellStyle(col.header, rowData)" (click)="filterHighRiskTableByIds(rowData, col)">
                              <!-- <span tabindex="0"  (click)="filterHighRiskTableByIds(rowData, col.field)"> -->
                                {{ totalCount(rowData, col) }} 
                              <!-- </span> -->
                            </td>
                        </tr>
                    </ng-template>
                </p-table> 
            </div>
        </div>
    </p-card>
</div>
</div>

<p-dialog
[style]="{ width: '90vw', height: '37vw' }"
[(visible)]="showRiskScoreChart"
[maximizable]="true"
>
<p-header>
<h4>User Score</h4>
{{ isDeId(selectedAdminData["employeeName"]) }} ID:{{ selectedAdminData["lanId"] }}
<p-button
  icon="pi pi-info"
  [rounded]="true"
  [text]="true"
  severity="info"
  styleClass="user-score-info-button"
  ariaLabel="About User Score"
  (click)="showMaapInfo()">
</p-button>
</p-header>
<app-risk-score-chart #riskScoreChart></app-risk-score-chart>
</p-dialog>

<p-dialog header="An Understanding of User Score" [(visible)]="maapRiskInfo" appendTo="body" [style]="{width: '30vw'}">
    <p>User Score is an analytically driven score thatâ€™s an indicator of a heathcare workerâ€™s potential risk for drug diversion over a moving 90-day period. Score contributions include but are not limited to the following:</p>
  <ul>
    <li>Total Number of High-Risk Variances</li>
    <li>Age of High-Risk Variances</li>
    <li>Peer Audit Scores</li>
    <li>Date of Occurrence of Variances</li>
    <li> <p>DEA Classification of Medications</p></li>  
      <ul>
        <li><a href="https://www.dea.gov/drug-information/drug-scheduling" target="_blank" class="success-link">Drug Scheduling</a></li>
        <li><a href="https://www.deadiversion.usdoj.gov/schedules/orangebook/c_cs_alpha.pdf" target="_blank" class="success-link">Controlled Substances</a></li>
      </ul>
    <li class="dialog-list-final">User Score is calculated daily and over a rolling 90 days</li>
  </ul>
  </p-dialog>

  <p-dialog
    [(visible)]="individualDiscrepancyDialog"
    [style]="{ width: '98vw' }"
    [maximizable]="true"
    [resizable]="true"
    (onShow)="onShowModal()"
    (onHide)="onHideModal()"
  >
    <p-header>
      <h4>Individual Activity</h4>
      Name: {{ isDeId(selectedAdminData["employeeName"]) }}, ID:{{ isDeId(selectedAdminData["lanId"]) }}
    </p-header>
    <div class="row">
      <div class="col"></div>
      <div class="col-6 tableDateRange">
         <p class="date-range"> <b>Start Date:</b> {{date.startDate | date : 'MM/dd/yyyy HH:mm'}} <br> <b>End Date:</b> {{date.endDate | date : 'MM/dd/yyyy HH:mm'}} </p>
      </div>
      <div class="col"></div>
    </div>
    <div class="row">
      <div class="col"></div>
      <div class="col-3 pSelectBTN">
        <p-selectButton  class="days-selection" (onChange)="updateLookbackPeriod($event)" [options]="days" [(ngModel)]="selectedDays"></p-selectButton>
      </div>
      <div class="col"></div>
    </div>
    <div class="row dialog-summary-row">
      <div class="col"></div>
      <div class="col-6 text-center">
        <span class="dialog-summary-label">High Risk Count: </span>
        <span>{{ selectedAdminData.highRisk }}</span>
      </div>
      <div class="col"></div>
    </div>
    <app-data-filter-pills [filterValues]="iaFilter" [deId]="deId" (filterVal)="removeFilter($event)" (filterInputs)="openFilterModuleAfterMore($event)"></app-data-filter-pills>
    <app-urc
      #varianceComponent
      *ngIf="individualDiscrepancyDialog"
      [auditRow]="sendSelectedRow('highRisk')"
      [deId]="deId"
      [isAuditor]="true"
      [auditRiskLevel]="'highRisk'"
      [lookbackPeriod]="selectedDays"
      (filterValue)="getFilterPillsValues($event)"
      (shareIndvActiv)="openInvActShareModalRisks()"
      (dateValue)="updatedDate($event)"
    ></app-urc>
  </p-dialog>

  <p-dialog
    [(visible)]="individualActivityDialog"
    [style]="{ width: '98vw' }"
    [maximizable]="true"
    [resizable]="true"
    (onShow)="onShowModal()"
    (onHide)="onHideModal()"
  >
  <p-header>
    <h4>Individual Activity</h4>
    {{ isDeId(selectedAdminData["employeeName"]) }} ID:{{ selectedAdminData["lanId"] }}
  </p-header>
  <div class="row">
    <div class="col">
    </div>
    <div class="col-6" class="tableDateRange">
       <p class="date-range"> <b>Start Date:</b> {{date.startDate| date : 'MM/dd/yyyy HH:mm'}} <br> <b>End Date:</b> {{date.endDate| date : 'MM/dd/yyyy HH:mm'}}</p>
    </div>
    <div class="col">
    </div>
  </div>
  <div class="row">
    <div class="col">
    </div>
    <div class="col-3" class="pSelectBTN">
      <p-selectButton  class="days-selection" (onChange)="updateLookbackPeriod($event)" [options]="days" [(ngModel)]="selectedDays"></p-selectButton>
    </div>
    <div class="col">
    </div>
  </div>
    <app-data-filter-pills [filterValues]="iaFilter" (filterVal)="removeFilter($event)"></app-data-filter-pills>
    <app-urc
      #varianceComponent
      *ngIf="individualActivityDialog"
      [auditRow]="sendSelectedRow('tvs')"
      [deId]="deId"
      [isAuditor]="true"
      [lookbackPeriod]="selectedDays"
      [auditRiskLevel]="'tvs'"
      (filterValue)="getFilterPillsValues($event)"
      (shareIndvActiv)="openInvActShareModalRisks()"
      (dateValue)="updatedDate($event)"
    ></app-urc>
  </p-dialog>

  <p-dialog
    header="Change Follow-Up Status, Share, and/or Add or Delete Documents"
    [style]="{ width: '60vw' }"
    [(visible)]="commentDialog"
    (onShow)="onShowModal()"
    (onHide)="onHideModal()"
  >
    <app-notes-modal
      #notesComponent
      [selectedRow]="selectedAdminData"
      [deId]="deId"
      [lookbackPeriod]="this.filter.duration"
      (completed)="submitMessageCompleted($event)"
      (shareAdminStatus)="openFollowUpShare($event)"
      (investigativeSummary) = "openInvestigativeSummary()"
    >
    </app-notes-modal>
  </p-dialog>

<p-dialog  
    [(visible)] = "showInvestigativeSummary"
    [selectedRow]="selectedRow"
    appendTo="body" 
    [style]="{width: '90vw', height: '70vw'}"
    [maximizable]="true"
    >
    <p-header>
    <h4>Investigative Summary Report</h4>
    {{ isDeId(selectedRow["employeeName"]) }} ID: {{ selectedRow["lanId"] }}
    <div class="transactions-box-buttons">
        <span pTooltip="Share" tooltipPosition="bottom">
            <button class="transBtnStyle" (click)="openISShareModal()"><i class="pi pi-share-alt"></i></button>
        </span>
        <span pTooltip="Print" tooltipPosition="bottom">
            <button class="transBtnStyle" (click)="openISPrintModal()"><i class="pi pi-print"></i></button>
        </span>   
    </div>  
    </p-header>
    <p-divider align="left" type="solid">
      <b>SELECT ROWS FOR <i class="pi pi-share-alt dialog-action-icon"></i> <i class="pi pi-print dialog-action-icon"></i></b>
    </p-divider>
    <app-investigative-summary class="row w-100" #investigativeSummary [record]="selectedRow"></app-investigative-summary>
</p-dialog>

<p-dialog 
  [(visible)]="showShareModal" 
  [resizable]="false" 
  [style]="{'width':'90vw', 'height':'80%'}"
  header="Email Share"
  >
  <app-share-modal #shareModal  [deId]="deId" (closeModal)="closeShareModal()" (completed)="submitMessageCompleted($event)"> </app-share-modal>
</p-dialog>

<p-dialog
header="Update Variance Type"
[style]="{ width: '60vw' }"
[(visible)]="followUpDialog"
(onShow)="onShowModal()"
(onHide)="onHideModal()"
>
<app-follow-up-modal
  #fdialog
  [selectedRow]="selectedRow"
  [deId]="deId"
  (completed)="submitMessageCompleted($event)"
>
</app-follow-up-modal>
</p-dialog>
      
      <!-- <p-dialog header="Filter by Date" [(visible)]="dateSelector" [style]="{width: '50vw'}">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label style="display:block;">START DATE</label>
                    <p-calendar appendTo="body" (onSelect)="updateEndDate()" [(ngModel)]="filter.startDate"></p-calendar>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label style="display:block;">END DATE </label>
                    <p-calendar appendTo="body" [(ngModel)]="filter.endDate"></p-calendar>
                </div>
            </div>
        </div>
        <ng-template pTemplate="footer">
            <p-button icon="pi pi-times" (click)="dateSelector = false" label="Cancel" styleClass="p-button-text"></p-button>
            <p-button icon="pi pi-check" (click)="submitDateSelector()" label="Submit" styleClass="p-button-text"></p-button>
        </ng-template>
    </p-dialog> -->
